var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMainTabActive)?_c('AuthEvents',{class:_vm.theme.profile.profile,scopedSlots:_vm._u([{key:"tabs",fn:function(){return [_c('span',{class:[_vm.theme.profile.text, _vm.theme.profile.large, _vm.theme.profile.extrabold, _vm.theme.profile.black]},[_vm._v(" History ")])]},proxy:true}],null,false,1432008236)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }